<div class="mc-spring-board">
  <div class="mc-spring-board-header">
    <button type="button" color="primary" mat-raised-button (click)="connectorSelected.next()">
      <div class="mc-d-flex mc-align-items-center">
        <mat-icon class="mc-baseline-text-icon" [fontSet]="'project-titan'" [fontIcon]="'icon-add'"></mat-icon>
        <span>New Connector</span>
      </div>
    </button>
  </div>
  <div class="mc-spring-board-body">
    <div class="mc-license-connectors-list-details-view-grid">
      <button mat-raised-button *ngFor="let licenseConnector of licenseConnectors$ | async" (click)="connectorSelected.next(licenseConnector)">

        <ng-container *ngIf="licenseConnector.ConnectionType === ConnectionType.Syndicate">
          <div class="mc-details-view">
            <img alt="Syndicate Logo" class="mc-details-view-image" src="assets/images/syndicate-logo.svg" />
            <div class="mc-details-view-text-wrapper">
              <div class="mc-truncate mc-details-view-title" [matTooltip]="licenseConnector.Name">
                {{licenseConnector.Name}}
              </div>
              <div class="mc-truncate mc-text-muted" [matTooltip]="licenseConnector.Url">
                {{licenseConnector.Url}}
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="licenseConnector.ConnectionType === ConnectionType.FTP">
          <div class="mc-details-view">
            <mat-icon class="mc-details-view-icon" fontSet="project-titan" fontIcon="icon-ftp"></mat-icon>
            <div class="mc-details-view-text-wrapper">
              <span class="mc-truncate mc-details-view-title" [matTooltip]="licenseConnector.Name">
                {{licenseConnector.Name}}
              </span>
              <span class="mc-truncate mc-text-muted" [matTooltip]="licenseConnector.Url">
                {{licenseConnector.Url}}
              </span>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="licenseConnector.ConnectionType === ConnectionType.SFTP">
          <div class="mc-details-view">
            <mat-icon class="mc-details-view-icon" fontSet="project-titan" fontIcon="icon-sftp"></mat-icon>
            <div class="mc-details-view-text-wrapper">
              <span class="mc-truncate mc-details-view-title" [matTooltip]="licenseConnector.Name">
                {{licenseConnector.Name}}
              </span>
              <span class="mc-truncate mc-text-muted" [matTooltip]="licenseConnector.Url">
                {{licenseConnector.Url}}
              </span>
            </div>
          </div>
        </ng-container>
      </button>
    </div>
  </div>
  <mc-loader *ngIf="loadingState.loading$ | async"></mc-loader>
  <div *ngIf="loadingState.generalError$ | async as generalError" class="error-pane">
    <mc-errors-expansion-panel [generalError]="generalError" [detailedErrors]="loadingState.detailedErrors$ | async"></mc-errors-expansion-panel>
  </div>
</div>